import GoogleButton from "react-google-button";
import "./Registration.css";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth, db } from "../../../firebaseConfig";
import { useDispatch } from "react-redux";
import { login } from "../../../redux/features/userSlice";
import { child, onValue, ref, set } from "firebase/database";
import logo from "../../../assets/img/logo4.png";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigate } from "react-router-dom";
import EastIcon from "@mui/icons-material/East";
import { useState } from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

export default function Registration() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [therapyType, setTherapyType] = useState("");
  const [isRegistrationDiv, setIsRegistrationDiv] = useState(false);

  const googleSignIn = () => {
    const provider = new GoogleAuthProvider();

    signInWithPopup(auth, provider)
      .then(async (result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        // const credential = GoogleAuthProvider.credentialFromResult(result);
        // const token = credential.accessToken;
        // The signed-in user info.
        const user = result.user;
        // IdP data available using getAdditionalUserInfo(result)
        if (user) {
          const userRef = ref(db, "users/" + user?.uid);

          await AsyncStorage.setItem("@user", JSON.stringify(user));
          onValue(userRef, (snapshot) => {
            const userData = snapshot?.val();
            if (userData) {
              // USER EXISTS

              dispatch(
                login({
                  displayName: userData?.displayName || "",
                  photoURL: userData?.photoURL || "",
                  email: userData?.email || "",
                  uid: userData?.uid || "",
                  phoneNumber: userData?.phoneNumber || "",
                  paid: userData?.paid || 0,
                  physicalSessions: userData?.physicalSessions || 0,
                  voiceSessions: userData?.voiceSessions || 0,
                  videoSessions: userData?.videoSessions || 0,
                  bio: userData?.bio || "",
                  therapyType: userData?.therapyType,
                })
              );
              navigate("/therapists");
            } else {
              set(userRef, {
                displayName: user?.displayName || "",
                photoURL: user?.photoURL || "",
                email: user?.email || "",
                uid: user?.uid || "",
                phoneNumber: user?.phoneNumber || "",
                paid: 0,
                physicalSessions: 0,
                voiceSessions: 0,
                videoSessions: 0,
                therapyType: therapyType,
              });
              dispatch(
                login({
                  displayName: user?.displayName || "",
                  photoURL: user?.photoURL || "",
                  email: user?.email || "",
                  uid: user?.uid || "",
                  phoneNumber: user?.phoneNumber || "",
                  paid: 0,
                  physicalSessions: 0,
                  voiceSessions: 0,
                  videoSessions: 0,
                  therapyType: therapyType,
                })
              );
              navigate("/therapists");
            }
          });

          const therapistRef = ref(db, "therapists");
          onValue(therapistRef, (snapshot) => {
            const therapistData = snapshot?.val();
            if (therapistData) {
              if (Object.keys(therapistData).includes(user.uid)) {
                const theraRef = ref(db, `therapists/${user?.uid}`);
                if (therapistData[user.uid].photoURL) {
                  dispatch(login(therapistData[user.uid]));
                } else {
                  const theraChildRef = child(theraRef, "photoURL");
                  let photourl = `${user?.photoURL}`;

                  set(theraChildRef, photourl);
                  // Dispatch the action to update the name in the Redux store
                  const updatedUser = {
                    ...user,
                    displayName: therapistData[user.uid].displayName,
                    photoURL: user?.photoURL || "",
                  };
                  dispatch(login(updatedUser));
                }
              }
            }
          });
        }
      })
      .catch((error) => {
        // const errorCode = error.code;
        // const errorMessage = error.message;
        // const credential = GoogleAuthProvider.credentialFromError(error);
      });
  };

  const handleGoogleSignIn = async () => {
    try {
      googleSignIn();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="registration">
      <div className="reg-container">
        <div className="reg-div">
          <div className={`reg-types ${!isRegistrationDiv && "active"}`}>
            <div
              className="reg-type individual"
              onClick={() => {
                setTherapyType("Individual");
                setIsRegistrationDiv(true);
              }}
            >
              <h2>Individual</h2>
              <EastIcon className="east-icon" />
            </div>
            <div
              className="reg-type corporate"
              onClick={() => {
                setTherapyType("Corporate");
                setIsRegistrationDiv(true);
              }}
            >
              <h2>Corporate</h2>
              <EastIcon className="east-icon" />
            </div>
          </div>

          <div className={`registration-div ${isRegistrationDiv && "active"}`}>
            <KeyboardBackspaceIcon
              onClick={() => {
                setIsRegistrationDiv(false);
                setTherapyType("");
              }}
              className="back-arrow"
            />
            <img src={logo} className="reg-logo" alt="vibes and vent" />
            <h2 className="sub-header-reg">
              Vent out your heart, mind and soul.
            </h2>
            <GoogleButton onClick={handleGoogleSignIn} className="google-btn" />
            <p>
              By Signing up as{" "}
              <span style={{ color: "#00b7b2", fontWeight: "600" }}>
                {therapyType}
              </span>
              , you agree to our <a href="https://vibesandvent.org">Terms</a>,{" "}
              <a href="https://vibesandvent.org">Privacy</a> and{" "}
              <a href="https://vibesandvent.org">Cookie</a> use.
            </p>
            <p>Welcome to Vibes and Vent.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
